import { render, staticRenderFns } from "./PartCustomerDetailCard.vue?vue&type=template&id=f38f0fbc"
import script from "./PartCustomerDetailCard.vue?vue&type=script&lang=js"
export * from "./PartCustomerDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports